import React, { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { jwtClient } from "utils/jwtClient";

type AuthCallbackProps = {
  setIsAuthenticated: (value: boolean) => void;
};

export const AuthCallback: React.FC<AuthCallbackProps> = ({
  setIsAuthenticated,
}) => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const codeVerifier = window.sessionStorage.getItem("code_verifier");

  useEffect(() => {
    const getTokenWithAuthorizationCode = async () => {
      await jwtClient.getTokenWithAuthorizationCode(code, codeVerifier);
      setIsAuthenticated(jwtClient.isAuthenticated());
    };
    if (!jwtClient.isAuthenticated()) {
      getTokenWithAuthorizationCode();
    }
  }, []);

  return <Navigate to="/" />;
};
